"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[7461],{

/***/ 65188:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dc": () => (/* binding */ linkToClinicAdminBillingManagement),
/* harmony export */   "ED": () => (/* binding */ linkToClinicAdminInsurance),
/* harmony export */   "Hb": () => (/* binding */ linkToClinicAdminControlPanel),
/* harmony export */   "M4": () => (/* binding */ linkToClinicAdminFacilityReports)
/* harmony export */ });
/* unused harmony export linkToClinicAdmin */
function linkToClinicAdmin() {
  return "/clinic-admin";
}
function linkToClinicAdminBillingManagement() {
  return `${linkToClinicAdmin()}/billing-management`;
}
function linkToClinicAdminControlPanel() {
  return `${linkToClinicAdmin()}/control-panel`;
}
function linkToClinicAdminFacilityReports() {
  return `${linkToClinicAdmin()}/facility-reports`;
}
function linkToClinicAdminInsurance() {
  return `${linkToClinicAdmin()}/insurance`;
}


/***/ }),

/***/ 29397:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qu": () => (/* binding */ BreadcrumbNav),
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "aG": () => (/* binding */ Breadcrumb),
/* harmony export */   "xI": () => (/* binding */ BackButtonCrumb)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52018);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12850);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69525);
/* harmony import */ var _elephant_healthcare_mui_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40252);
/* harmony import */ var _elephant_healthcare_mui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46828);





const Crumb = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("li")(({ theme }) => ({
  transition: "color 0.25s",
  fontSize: theme.typography.subtitle1.fontSize,
  fontWeight: 800,
  color: theme.palette.primary.main,
  "&:hover": {
    color: theme.palette.primary.light
  },
  "&:active": {
    color: theme.palette.primary.dark
  },
  "&:not(:first-child)::before": {
    content: '">"',
    marginRight: theme.spacing(1),
    color: "black"
  },
  "&:nth-last-child(-n +2)": {
    color: "revert"
  },
  [theme.breakpoints.down("xs")]: {
    display: "none"
  }
}));
const MobileCrumb = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Crumb)(({ theme }) => ({
  [theme.breakpoints.down("xs")]: {
    display: "revert"
  },
  [theme.breakpoints.up("sm")]: {
    display: "none"
  },
  "&::before": {
    display: "none"
  }
}));
const Breadcrumb = ({
  label,
  to,
  dataTestId,
  ...delegateProps
}) => {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  let labelText;
  if (typeof label === "string") {
    labelText = label;
  } else {
    labelText = formatMessage(label);
  }
  let child;
  if (!to) {
    child = labelText;
  } else if (typeof to === "string") {
    child = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_link__WEBPACK_IMPORTED_MODULE_1__/* .UnstyledLink */ .H, {
      to
    }, labelText);
  } else {
    child = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_link__WEBPACK_IMPORTED_MODULE_1__/* .UnstyledLink */ .H, {
      to,
      state: to.state
    }, labelText);
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Crumb, {
    "data-testid": dataTestId,
    ...delegateProps
  }, child);
};
const BreadcrumbContainer = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("ol")(({ theme }) => ({
  listStyle: "none",
  display: "inline-flex",
  margin: 0,
  padding: 0,
  gap: theme.spacing(1)
}));
const BreadcrumbNav = ({
  children
}) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("nav", {
  "aria-label": "breadcrumbs"
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbContainer, null, children));
const BackButtonLink = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_elephant_healthcare_mui_link__WEBPACK_IMPORTED_MODULE_1__/* .UnstyledLink */ .H)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(1)
}));
const BackButtonCrumb = ({ to }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(MobileCrumb, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BackButtonLink, {
  to
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_mui_icon__WEBPACK_IMPORTED_MODULE_2__.ArrowLeftLightIcon, null), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
  id: "nav.backButton",
  defaultMessage: "Previous page"
})));
const Breadcrumbs = ({ links }) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbNav, null, links.map((l) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Breadcrumb, {
  key: typeof l.label === "string" ? l.label : l.label.id,
  ...l
})), links.length > 1 && links[links.length - 2].to && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BackButtonCrumb, {
  to: links[links.length - 2].to
}));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Breadcrumbs);


/***/ }),

/***/ 70503:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "_c": () => (/* binding */ clinicControlPanelCrumb),
/* harmony export */   "xr": () => (/* binding */ homeCrumb)
/* harmony export */ });
/* unused harmony export patientsCrumb */
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11313);
/* harmony import */ var _patient_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90806);
/* harmony import */ var _links__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82303);
/* harmony import */ var _patient_search_links__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87268);
/* harmony import */ var _clinic_admin_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65188);





const breadcrumbMessages = (0,react_intl__WEBPACK_IMPORTED_MODULE_1__/* .defineMessages */ .vU)({
  home: {
    id: "breadcrumb.home.label",
    defaultMessage: "Home"
  },
  patients: {
    id: "breadcrumb.patients.label",
    defaultMessage: "Patients list"
  },
  patientOverview: {
    id: "breadcrumb.patientOverview.label",
    defaultMessage: "Patient overview"
  },
  billingManagement: {
    id: "breadcrumb.billingManagement.label",
    defaultMessage: "Billing management"
  },
  facilityReports: {
    id: "breadcrumb.facilityReports.label",
    defaultMessage: "Facility reports"
  },
  updatePatient: {
    id: "breadcrumb.updatePatient.label",
    defaultMessage: "Edit patient"
  },
  newPatient: {
    id: "breadcrumb.newPatient.label",
    defaultMessage: "Add new patient"
  },
  reissueCard: {
    id: "breadcrumb.reissueCard.label",
    defaultMessage: "Re-issue card"
  },
  investigationItemGenerator: {
    id: "breadcrumb.admin.investigations.itemGenerator",
    defaultMessage: "Item generator"
  },
  inpatientAdmit: {
    id: "breadcrumb.inpatient.admit",
    defaultMessage: "Inpatient admission"
  },
  clinicControlPanel: {
    id: "controlpanel.breadcrumb",
    defaultMessage: "Control Panel"
  },
  userSettings: {
    id: "breadcrumb.userSettings.label",
    defaultMessage: "User Settings"
  }
});
const homeCrumb = {
  label: breadcrumbMessages.home,
  to: (0,_links__WEBPACK_IMPORTED_MODULE_2__/* .linkToHome */ .J4)(),
  dataTestId: "Crumb.Home"
};
const patientOverviewCrumb = (patientUuid) => ({
  label: breadcrumbMessages.patientOverview,
  to: (0,_patient_links__WEBPACK_IMPORTED_MODULE_0__/* .linkToPatientDetails */ .V)({ patientUuid }),
  dataTestId: "Crumb.PatientOverview"
});
const clinicControlPanelCrumb = {
  label: breadcrumbMessages.clinicControlPanel,
  to: (0,_clinic_admin_links__WEBPACK_IMPORTED_MODULE_3__/* .linkToClinicAdminControlPanel */ .Hb)()
};
const patientsCrumb = {
  label: breadcrumbMessages.patients,
  to: (0,_patient_search_links__WEBPACK_IMPORTED_MODULE_4__/* .linkToPatientSearchResults */ .m)(),
  dataTestId: "Crumb.Patients"
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  admin: {
    billing: [homeCrumb, { label: breadcrumbMessages.billingManagement }],
    investigations: {
      itemGenerator: [
        homeCrumb,
        { label: breadcrumbMessages.investigationItemGenerator }
      ]
    }
  },
  clinicAdmin: {
    billing: [homeCrumb, { label: breadcrumbMessages.billingManagement }],
    facilityReports: [homeCrumb, { label: breadcrumbMessages.facilityReports }]
  },
  patient: {
    reissueCard: (patientId) => [
      homeCrumb,
      patientsCrumb,
      patientOverviewCrumb(patientId),
      { label: breadcrumbMessages.reissueCard }
    ],
    inpatient: {
      admit: (patientId) => [
        homeCrumb,
        patientsCrumb,
        patientOverviewCrumb(patientId),
        { label: breadcrumbMessages.inpatientAdmit }
      ]
    }
  },
  edit: {
    patient: (patientId) => [
      homeCrumb,
      patientsCrumb,
      patientOverviewCrumb(patientId),
      { label: breadcrumbMessages.updatePatient }
    ]
  },
  new: {
    patient: [homeCrumb, { label: breadcrumbMessages.newPatient }]
  },
  userSettings: [homeCrumb, { label: breadcrumbMessages.userSettings }]
});


/***/ }),

/***/ 88159:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ user_settings_UserSettingsPage)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-page@0.4.3_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-page/dist/index.js
var dist = __webpack_require__(48534);
// EXTERNAL MODULE: ./src/client/components/Breadcrumbs/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(29397);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/client/routes/breadcrumbs.ts
var breadcrumbs = __webpack_require__(70503);
// EXTERNAL MODULE: ./src/client/components/Layout/AppLayout.tsx
var AppLayout = __webpack_require__(34651);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+launchdarkly-provider@1.4.4_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/launchdarkly-provider/dist/module.js
var dist_module = __webpack_require__(45309);
// EXTERNAL MODULE: ./src/client/routes/NavigateHome.tsx
var NavigateHome = __webpack_require__(55558);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Tabs/Tabs.js + 2 modules
var Tabs = __webpack_require__(57626);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(76920);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(77572);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/user-settings/components/__generated__/ConsentTab.gql.ts


const defaultOptions = {};
const UpdateUserConsentSettingsDocument = lib/* gql */.Ps`
    mutation UpdateUserConsentSettings($input: UpdateUserInput!) {
  updateUser(input: $input) {
    _id
    person {
      whatsappConsent
      telephone
    }
  }
}
    `;
function useUpdateUserConsentSettingsMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UpdateUserConsentSettingsDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+react-hook-form-input@0.1.7_sjfm3rrfwwtsx5okgtvvldeidu/node_modules/@elephant-healthcare/react-hook-form-input/dist/module.js
var react_hook_form_input_dist_module = __webpack_require__(29054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var mui_toast_dist = __webpack_require__(28841);
var mui_toast_dist_default = /*#__PURE__*/__webpack_require__.n(mui_toast_dist);
// EXTERNAL MODULE: ./src/client/forms/hookForm/index.ts
var hookForm = __webpack_require__(86347);
;// CONCATENATED MODULE: ./src/client/user-settings/components/ConsentTab.tsx












lib/* gql */.Ps`
  mutation UpdateUserConsentSettings($input: UpdateUserInput!) {
    updateUser(input: $input) {
      _id
      person {
          whatsappConsent
          telephone
      }
    }
  }
`;
const ConsentTab = ({ user: { _id, person } }) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [updateUser] = useUpdateUserConsentSettingsMutation({
    onCompleted: () => mui_toast_dist_default().success(
      formatMessage({
        id: "userSettings.consent.updateSucceeded",
        defaultMessage: "User consent settings have been updated!"
      })
    ),
    onError: (error) => mui_toast_dist_default().error(
      formatMessage(
        {
          id: "userSettings.consent.updateFailed",
          defaultMessage: "Failed to update user consent settings: {message}"
        },
        { message: error.message }
      )
    )
  });
  async function handleSubmit(formValues) {
    var _a;
    await updateUser({
      variables: {
        input: {
          _id,
          person: {
            whatsappConsent: (_a = formValues.whatsappConsent) != null ? _a : false,
            telephone: formValues.telephone
          }
        }
      }
    });
  }
  return /* @__PURE__ */ react.createElement(ConsentTabForm, {
    whatsappConsent: person.whatsappConsent,
    telephone: person.telephone,
    onSubmitForm: handleSubmit
  });
};
const Heading = (0,styled/* default */.Z)(Typography/* default */.Z)(({ theme }) => ({
  marginTop: 24,
  marginBottom: 8
}));
const Subheading = (0,styled/* default */.Z)(Typography/* default */.Z)(({ theme }) => ({
  marginTop: 16,
  marginBottom: 16,
  [theme.breakpoints.up("sm")]: {
    maxWidth: "70%"
  }
}));
const FormFieldsBox = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  maxWidth: "60%",
  gap: theme.spacing(2),
  marginTop: 16,
  marginBottom: 8
}));
const WHATSAPP_CONSENT = "whatsappConsent";
const TELEPHONE = "telephone";
const consentTabSchema = es.object({
  [WHATSAPP_CONSENT]: es.boolean(),
  [TELEPHONE]: es.string()
});
const ConsentTabForm = ({
  whatsappConsent,
  telephone,
  onSubmitForm
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const formMethods = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(consentTabSchema),
    defaultValues: { whatsappConsent, telephone }
  });
  const whatsappConsentLabel = formatMessage({
    id: "userSettings.tab.consent.whatsappConsent.label",
    defaultMessage: "By ticking this box, you confirm that you are happy for us to send you communications over WhatsApp"
  });
  const telephoneLabel = formatMessage({
    id: "userSettings.tab.consent.mobilePhone.label",
    defaultMessage: "Mobile phone number"
  });
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    "aria-label": "Consent settings form",
    onSubmit: formMethods.handleSubmit(onSubmitForm)
  }, /* @__PURE__ */ react.createElement(Heading, {
    variant: "h1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "userSettings.tab.consent.heading",
    defaultMessage: "WhatsApp Communication Consent"
  })), /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(Subheading, {
    variant: "subtitle1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "userSettings.tab.consent.subheading",
    defaultMessage: "We are using WhatsApp for our communications about product releases, support and other important information for our users and partners"
  })), /* @__PURE__ */ react.createElement(FormFieldsBox, null, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* CheckboxField */.ji, {
    name: WHATSAPP_CONSENT,
    label: whatsappConsentLabel
  }), /* @__PURE__ */ react.createElement(TelephoneField, {
    name: TELEPHONE,
    label: telephoneLabel
  })), /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SubmitButton */.Mm, {
    size: "small",
    type: "submit",
    "data-testid": "user-settings-consent-form-submit-button",
    disabled: formMethods.formState.isSubmitting,
    loading: formMethods.formState.isSubmitting
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "userSettings.tab.consent.form.sumbit",
    defaultMessage: "Save"
  }))));
};
const TelephoneField = ({
  name,
  label
}) => {
  const whatsappConsentSet = !!(0,index_esm/* useWatch */.qo)({
    name: "whatsappConsent"
  });
  return /* @__PURE__ */ react.createElement(hookForm/* RHFTextField */.au, {
    name,
    label,
    required: whatsappConsentSet
  });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/user-settings/__generated__/UserSettingsPage.gql.ts


const UserSettingsPage_gql_defaultOptions = {};
const UserSettingsDocument = lib/* gql */.Ps`
    query UserSettings {
  myUser {
    _id
    person {
      whatsappConsent
      telephone
      firstname
      middlename
      lastname
    }
  }
}
    `;
function useUserSettingsQuery(baseOptions) {
  const options = { ...UserSettingsPage_gql_defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(UserSettingsDocument, options);
}
function useUserSettingsLazyQuery(baseOptions) {
  const options = { ...UserSettingsPage_gql_defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(UserSettingsDocument, options);
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-loading-layout@0.4.0_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-loading-layout/dist/module.js
var mui_loading_layout_dist_module = __webpack_require__(69638);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
;// CONCATENATED MODULE: ./src/client/user-settings/components/__generated__/PersonalInfoTab.gql.ts


const PersonalInfoTab_gql_defaultOptions = {};
const UpdateUserPersonalInfoSettingsDocument = lib/* gql */.Ps`
    mutation UpdateUserPersonalInfoSettings($input: UpdateUserInput!) {
  updateUser(input: $input) {
    _id
    person {
      firstname
      middlename
      lastname
    }
  }
}
    `;
function useUpdateUserPersonalInfoSettingsMutation(baseOptions) {
  const options = { ...PersonalInfoTab_gql_defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(UpdateUserPersonalInfoSettingsDocument, options);
}

;// CONCATENATED MODULE: ./src/client/user-settings/components/PersonalInfoTab.tsx











lib/* gql */.Ps`
  mutation UpdateUserPersonalInfoSettings($input: UpdateUserInput!) {
    updateUser(input: $input) {
      _id
      person {
          firstname
          middlename
          lastname
      }
    }
  }
`;
const PersonalInfoTab = ({
  user: { _id, person }
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [updateUser] = useUpdateUserPersonalInfoSettingsMutation({
    onCompleted: () => mui_toast_dist_default().success(
      formatMessage({
        id: "userSettings.personal.updateSucceeded",
        defaultMessage: "User personal info has been updated!"
      })
    ),
    onError: (error) => mui_toast_dist_default().error(
      formatMessage(
        {
          id: "userSettings.personal.updateFailed",
          defaultMessage: "Failed to update user personal settings: {message}"
        },
        { message: error.message }
      )
    )
  });
  async function handleSubmit(formValues) {
    await updateUser({
      variables: {
        input: {
          _id,
          person: {
            firstname: formValues.firstname,
            middlename: formValues.middlename,
            lastname: formValues.lastname
          }
        }
      }
    });
  }
  return /* @__PURE__ */ react.createElement(PersonalInfoTabForm, {
    firstname: person.firstname,
    middlename: person.middlename,
    lastname: person.lastname,
    onSubmitForm: handleSubmit
  });
};
const PersonalInfoTab_Heading = (0,styled/* default */.Z)(Typography/* default */.Z)(({ theme }) => ({
  marginTop: 24,
  marginBottom: 8
}));
const PersonalInfoTab_FormFieldsBox = (0,styled/* default */.Z)("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  maxWidth: "60%",
  gap: theme.spacing(2),
  marginTop: 16,
  marginBottom: 8
}));
const FIRST_NAME = "firstname";
const MIDDLE_NAME = "middlename";
const LAST_NAME = "lastname";
const personalInfoTabSchema = es.object({
  [FIRST_NAME]: es.string().required("Please provide your first name"),
  [MIDDLE_NAME]: es.string(),
  [LAST_NAME]: es.string().required("Please provide your last name")
});
const PersonalInfoTabForm = ({
  firstname,
  middlename,
  lastname,
  onSubmitForm
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const formMethods = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(personalInfoTabSchema),
    defaultValues: { firstname, middlename, lastname }
  });
  const firstnameLabel = formatMessage({
    id: "userSettings.tab.personal.firstName.label",
    defaultMessage: "First name"
  });
  const middlenameLabel = formatMessage({
    id: "userSettings.tab.personal.middleName.label",
    defaultMessage: "Middle name"
  });
  const lastnameLabel = formatMessage({
    id: "userSettings.tab.personal.lastName.label",
    defaultMessage: "Last name"
  });
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    "aria-label": "Personal info settings form",
    onSubmit: formMethods.handleSubmit(onSubmitForm)
  }, /* @__PURE__ */ react.createElement(PersonalInfoTab_Heading, {
    variant: "h1"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "userSettings.tab.personal.heading",
    defaultMessage: "Personal information"
  })), /* @__PURE__ */ react.createElement(Divider/* default */.Z, null), /* @__PURE__ */ react.createElement(PersonalInfoTab_FormFieldsBox, null, /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* TextField */.nv, {
    name: FIRST_NAME,
    label: firstnameLabel,
    required: true
  }), /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* TextField */.nv, {
    name: MIDDLE_NAME,
    label: middlenameLabel
  }), /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* TextField */.nv, {
    name: LAST_NAME,
    label: lastnameLabel,
    required: true
  })), /* @__PURE__ */ react.createElement(react_hook_form_input_dist_module/* SubmitButton */.Mm, {
    size: "small",
    type: "submit",
    "data-testid": "user-settings-personal-info-form-submit-button",
    disabled: formMethods.formState.isSubmitting,
    loading: formMethods.formState.isSubmitting
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "userSettings.tab.personal.form.sumbit",
    defaultMessage: "Save"
  }))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@6.15.0_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-router-dom/dist/index.js
var react_router_dom_dist = __webpack_require__(58311);
;// CONCATENATED MODULE: ./src/client/user-settings/UserSettingsPage.tsx
















lib/* gql */.Ps`
    query UserSettings {
      myUser {
        _id
        person {
          whatsappConsent
          telephone
          firstname
          middlename
          lastname
        }
      }
    }
`;
var UserSettingsTabs = /* @__PURE__ */ ((UserSettingsTabs2) => {
  UserSettingsTabs2["Consent"] = "consent";
  UserSettingsTabs2["Personal"] = "personal";
  return UserSettingsTabs2;
})(UserSettingsTabs || {});
const tabComponentMap = {
  ["consent" /* Consent */]: ConsentTab,
  ["personal" /* Personal */]: PersonalInfoTab
};
function a11yProps(givenTab) {
  return {
    id: `user-settings-tab-${givenTab}`,
    "aria-controls": `user-settings-tab-${givenTab}`
  };
}
const Container = (0,styled/* default */.Z)("div")(() => ({
  padding: 32
}));
const UserSettingsPage = () => {
  var _a;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [searchParams, setSearchParams] = (0,react_router_dom_dist/* useSearchParams */.lr)();
  const tab = (_a = searchParams.get("selectedTab")) != null ? _a : "personal" /* Personal */;
  const handleTabChange = (_, newValue) => {
    setSearchParams({ selectedTab: newValue });
  };
  const { data, loading } = useUserSettingsQuery();
  const {
    flags: { [featureFlags/* featureFlags.user.whatsappConsent */.VH.user.whatsappConsent]: whatsappConsentFlagEnabled },
    loading: flagsLoading
  } = (0,dist_module/* useFeatureFlagContext */.dG)();
  const ActiveTab = (0,react.useMemo)(() => tabComponentMap[tab], [tab]);
  if (!flagsLoading && !whatsappConsentFlagEnabled) {
    return /* @__PURE__ */ react.createElement(NavigateHome/* default */.Z, null);
  }
  if (!data || !data.myUser || loading) {
    return /* @__PURE__ */ react.createElement(mui_loading_layout_dist_module/* default */.Z, null);
  }
  const myUser = data.myUser;
  return /* @__PURE__ */ react.createElement(AppLayout/* default */.Z, null, /* @__PURE__ */ react.createElement(dist.Page, null, /* @__PURE__ */ react.createElement(Breadcrumbs/* default */.ZP, {
    links: breadcrumbs/* default.userSettings */.ZP.userSettings
  }), /* @__PURE__ */ react.createElement(Container, null, /* @__PURE__ */ react.createElement(Tabs/* default */.Z, {
    indicatorColor: "primary",
    textColor: "primary",
    value: tab,
    variant: "fullWidth",
    onChange: (_, val) => handleTabChange(_, val),
    "aria-label": formatMessage({
      id: "userSettings.tabs.ariaLabel",
      defaultMessage: "user settings tabs"
    }),
    ...a11yProps(tab)
  }, /* @__PURE__ */ react.createElement(Tab/* default */.Z, {
    label: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "userSettings.tab.personal",
      defaultMessage: "Personal"
    }),
    value: "personal" /* Personal */,
    "data-testid": "userSettingsPersonalInfoTab",
    ...a11yProps(tab)
  }), /* @__PURE__ */ react.createElement(Tab/* default */.Z, {
    label: /* @__PURE__ */ react.createElement(message/* default */.Z, {
      id: "userSettings.tab.consent",
      defaultMessage: "Consent"
    }),
    value: "consent" /* Consent */,
    "data-testid": "userSettingsConsentTab",
    ...a11yProps(tab)
  })), /* @__PURE__ */ react.createElement(ActiveTab, {
    user: myUser
  }))));
};
/* harmony default export */ const user_settings_UserSettingsPage = (UserSettingsPage);


/***/ })

}]);